import { Component, ContentChild, TemplateRef,
    ChangeDetectionStrategy
} from '@angular/core';

type CompareMode = 'blend' | 'slider' | 'diff';

@Component({
    selector: 'app-compare-view',
    templateUrl: './compare-view.component.html',
    styleUrls: ['./compare-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompareViewComponent {

    @ContentChild('left') leftTpl!: TemplateRef<any>;
    @ContentChild('right') rightTpl!: TemplateRef<any>;

    mode: CompareMode = 'blend';
    activeLayer: 'left' | 'right' = 'left';
    
    slider = 50;

    get opacity(): number {
        return this.slider / 100;
    }

    get clipPathLeft(): string {
        return `inset(0 ${100 - this.slider}% 0 0)`;
    }

    get clipPathRight(): string {
        return `inset(0 0 0 ${this.slider}%)`;
    }
}
